import React from "react";
import { Typography } from "@/components/Typography";
import { PreviewCloudinaryImage, PreviewPrimaryAction } from "@/features/previews/shared";
import { LOGO_VARIANTS, SPACING, TYPOGRAPHY_CLASSES } from "../constants";

interface VcardHeaderVariantProps {
  logoUrl?: string;
  title?: string;
  subtitle?: string;
  themeColor?: {
    backgroundColor?: string;
    buttonColor?: string;
  };
  isInitialPreview?: boolean;
  primaryAction?: {
    text?: string;
    icon?: React.ReactNode;
    onClick?: () => void;
    dataQA?: string;
  };
  logoAlt?: string;
}

export const VcardHeaderVariant = ({
  logoUrl,
  title,
  subtitle,
  themeColor,
  isInitialPreview,
  primaryAction,
  logoAlt,
}: VcardHeaderVariantProps) => {
  const hasPrimaryAction = Boolean(primaryAction && title);

  return (
    <>
      <div
        className="preview-hero-header__background"
        style={{ background: themeColor?.backgroundColor }}
      >
        {logoUrl && (
          <div className="preview-hero-header__logo-container">
            <PreviewCloudinaryImage
              src={logoUrl}
              alt={logoAlt || "Avatar"}
              className="preview-hero-header__logo"
              placeholderClass="preview-hero-header__logo"
              variant={LOGO_VARIANTS.LOGO_LARGE}
              isInitPreview={isInitialPreview}
            />
          </div>
        )}

        {title && (
          <div className="preview-hero-header__title">
            <Typography
              Tag="p"
              size="l"
              classname={`${TYPOGRAPHY_CLASSES.SEMIBOLD} ${SPACING.MEDIUM}`}
            >
              {title}
            </Typography>
          </div>
        )}

        {subtitle && (
          <div className="preview-hero-header__subtitle">
            <Typography
              Tag="p"
              classname={SPACING.LARGE}
            >
              {subtitle}
            </Typography>
          </div>
        )}
      </div>

      {hasPrimaryAction && (
        <div className="u-line preview-hero-header__action">
          <PreviewPrimaryAction
            dataQA={primaryAction?.dataQA}
            iconLeft
            icon={primaryAction?.icon}
            spacing={2}
            text={primaryAction?.text}
            buttonColor={themeColor?.buttonColor}
            onClick={primaryAction?.onClick}
          />
        </div>
      )}
    </>
  );
};
